



























































































import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  name: "QrList"
})
export default class QrList extends Vue {
  @Prop({type: Array, default: []}) items!: any
  @Prop({type: String, default: ''}) type!: any

 get getTypeTitle(){
    let res;
    switch (this.type){
      case 'badge':
        res =  'Бэйджи'
            break;

      case 'product':
        res = 'Продукция'
        break;
      case 'stand':
        res =  'Стенды'
        break;
    }
    return res
  }
}
